module.exports = __webpack_public_path__ + "img/deal1.cbf41c94.jpg";